// extracted by mini-css-extract-plugin
export default {"content":"app_content__hfDIT","main":"app_main__rmRZz"};